// The stiletto: "Stiletto Knife" by 3dane (sketchfab.com/3dane, CC-BY-4.0), split by
// scripts/import-stiletto.mjs into the blade, the steel fittings (guard, bolsters, pommel, rivets) and
// the wooden scales. Held with the index finger on the bolster behind the guard and the thin blade
// forward; its inspect turns the wrist to stand it up at the right, flat to the camera (like CS2).

import * as THREE from 'three';
import { straightKnifeLoader } from './straightKnife';

export const loadStiletto = straightKnifeLoader({
  url: `${import.meta.env.BASE_URL ?? '/'}assets/models/stiletto.glb`,
  colors: { fittings: 0x26282d, scales: 0x4a2a18 },
  fitScale: 37,
  index: { part: 'scales', from: 'bladeEnd', offset: -0.012 },
  fistLength: 0.08,
  edgeSide: 1,
  inspect: {
    fist: new THREE.Vector3(0.06, -0.08, -0.5),
    across: new THREE.Vector3(-0.2, -1, 0.05),
    knuckles: new THREE.Vector3(-0.2, 0.1, -0.95),
    palm: false,
  },
});
